import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from '@/components/layout/AdminLayout/AdminLayout';
import AdminProtectedRoute from '@/context/AdminProtectedRoute';


// Dashboard Pages
const DashboardPage = lazy(() => import('../pages/Dashboard/DashboardPage'));

// Organization Pages
const OrganizationsPage = lazy(() => import('../pages/Organization/OrganizationPage'));
const OrganizationDetailsPage = lazy(() => import('../pages/Organization/OrganizationDetailsPage'));

// User Pages
const UsersPage = lazy(() => import('../pages/Users/UsersPage'));
const UserDetailsPage = lazy(() => import('../pages/Users/UserDetailsPage'));

// System Users Pages
const SystemUsersPage = lazy(() => import('../pages/SystemUsers/SystemUsersPage'));



const AdminRoutes = {
  path: '/',
  children: [
    // Root path redirect - moved outside of protected routes
    {
      path: '',
      element: <Navigate to="/dashboard" replace />
    },
    
    // Protected routes (require auth)
    {
      element: <AdminProtectedRoute />,
      children: [
        {
          element: <AdminLayout />,
          children: [
            {
              path: 'dashboard',
              element: (
                <Suspense>
                  <DashboardPage />
                </Suspense>
              )
            },
            // Organizations
            {
              path: 'organizations',
              element: (
                <Suspense>
                  <OrganizationsPage />
                </Suspense>
              )
            },
            {
              path: 'organizations/:id',
              element: (
                <Suspense>
                  <OrganizationDetailsPage />
                </Suspense>
              )
            },
            // Users
            {
              path: 'users',
              element: (
                <Suspense>
                  <UsersPage />
                </Suspense>
              )
            },
            {
              path: 'users/:id',
              element: (
                <Suspense>
                  <UserDetailsPage />
                </Suspense>
              )
            },
            // System Users
            {
              path: 'system-users',
              element: (
                <Suspense>
                  <SystemUsersPage />
                </Suspense>
              )
            }
          ]
        }
      ]
    },
    
    // Fallback for unknown admin routes
    {
      path: '*',
      element: <Navigate to="/dashboard" replace />
    }
  ]
};

export default AdminRoutes;